import { render, staticRenderFns } from "./SvgButton.vue?vue&type=template&id=b5204e98&"
import script from "./SvgButton.vue?vue&type=script&lang=js&"
export * from "./SvgButton.vue?vue&type=script&lang=js&"
import style0 from "./SvgButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports